import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { toast } from "react-toastify";
import "./model.css";
import "./addticket.css";
import axiosinstances from "../../Helper/useAxios";
import { useSelector } from "react-redux";

import { useNavigate } from "react-router-dom";
import moment from "moment";
import UILoader from "../../utils/comman/loader";

export default function AddAmount(props) {
  const navigate = useNavigate();
  const [amount, setAmount] = useState("");
  const userIp = useSelector((state) => state.userIpAddReducer.ip);
  const [axiosInstance] = axiosinstances(userIp);
  const { show, handleClose, headers, mid, fetchBalance } = props;

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setAmount("");

    return setAmount("");
  }, [show]);

  // const type
  const transferBalance = async () => {
    setLoading(true);

    const url = `/api/v1/upi/merchant/wallet/transfer/${mid}/${amount}/hash`;
    // setDataLoading(true);
    const response = await axiosInstance
      .post(url, {}, { headers })
      .then((res) => {
        if (res.status === 200 && res.data.transferAmount !== undefined) {
          toast.success(
            `${res.data?.transferAmount} Rs Amount has transfered successfully`
          );
          setLoading(false);

          fetchBalance();
          handleClose();
        }
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
        setAmount("");
      });

    if (response) {
      const result = response.data.tickets;

      if (result) {
      }

      return response.data;
    }
    setLoading(false);
    return false;
  };

  //Array.isArray(ticketLists) && ticketLists.length > 0
  //ticketLists

  // const openDetailsPage = (data) =>{
  //   navigate('/ticket-details',{state:{data:{id:selectedTicket}}})
  // }
  const showOptions = (val) => {
    const createdOn = moment(val?.createdOn).format("YYYY-MM-DD");
    const singleTicketOption = `${createdOn} ${val?.id} ${
      val.resolved ? "Closed" : "Open"
    }`;
    return singleTicketOption;
  };

  return (
    <>
      <Modal show={show} onHide={handleClose} dialogClassName="custom-modal">
        <Modal.Header closeButton>
          <Modal.Title>Transfer Payin to payout</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* Your modal body content here */}

          {loading ? (
            <UILoader />
          ) : (
            <div class="modal-body">
              <div class="container">
                {/* <!-- project  first row --> */}
                <div class="row">
                  <div class="col-12  mb-3">
                    <label for="manualTxn">
                      Amount <span class="text-danger">*</span>
                    </label>
                    <input
                      style={{ border: "1px solid green" }}
                      value={amount}
                      onChange={(e) => setAmount(e.target.value)}
                      type="text"
                      pattern="[0-9]*"
                      name="manualTxn"
                      id="manualTxn"
                      class="form-control border inputbg border-2"
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          {
            <Button
              disabled={loading}
              variant="primary"
              onClick={transferBalance}
            >
              Submit
            </Button>
          }
        </Modal.Footer>
      </Modal>
    </>
  );
}
